import Collapse from "bootstrap/js/src/collapse";
import {SET_HEADER_HEIGHT} from "../helpers/header-height";

const COLLAPSE_BREAKPOINT = '992px';

function GET_MAIN_HEADER() {
  return document.querySelector('[data-main-header]') || false;
}

function GET_MAIN_NAV() {
  return document.querySelector('[data-main-nav]') || false;
}

function HAS_NAV_MAX_WIDTH() {
  return window.matchMedia(`(max-width: ${COLLAPSE_BREAKPOINT})`);
}

function CHECK_FOR_SCROLL() {
  const MAIN_NAV = GET_MAIN_NAV();
  const MAIN_HEADER = GET_MAIN_HEADER();
  if (!MAIN_NAV || !MAIN_HEADER) return;

  if (window.scrollY > 50) {
    if (!MAIN_NAV.getAttribute('data-scrolled')) MAIN_NAV.setAttribute('data-scrolled', 'true');
    if (!MAIN_HEADER.getAttribute('data-scrolled')) MAIN_HEADER.setAttribute('data-scrolled', 'true');
  } else {
    MAIN_NAV.removeAttribute('data-scrolled');
    MAIN_HEADER.removeAttribute('data-scrolled');
  }
}

function INIT_TOGGLER() {
  const COLLAPSE_NAV = document.querySelector('[data-navbar-collapse]');
  if (!COLLAPSE_NAV) return;

  const MAIN_NAV = GET_MAIN_NAV();
  if (!MAIN_NAV) return;

  const MAIN_HEADER = GET_MAIN_HEADER();
  if (!MAIN_HEADER) return;

  COLLAPSE_NAV.addEventListener('show.bs.collapse', () => {
    MAIN_NAV.setAttribute('data-expanded', 'true');
    MAIN_HEADER.setAttribute('data-expanded', 'true');
  });

  COLLAPSE_NAV.addEventListener('hide.bs.collapse', () => {
    MAIN_NAV.setAttribute('data-expanded', 'false');
    MAIN_HEADER.setAttribute('data-expanded', 'false');
  })
}

function INIT_NAV_LINKS() {
  const mediaQuery = window.matchMedia(`(max-width: ${COLLAPSE_BREAKPOINT})`);
  const MAIN_NAV = GET_MAIN_NAV();
  if (!MAIN_NAV) return;
  const NAV_LINKS = MAIN_NAV.querySelectorAll('header .nav-link');

  NAV_LINKS.forEach(NAV_ITEM => {
    let currentURL = document.URL;
    const NAV_LINK = new URL(currentURL, NAV_ITEM.href),
      NAV_LINK_HASH = NAV_LINK.hash;

    NAV_ITEM.addEventListener('click', () => {
      if (mediaQuery.matches && NAV_LINK_HASH) {
        if (MAIN_NAV.getAttribute('data-expanded')) MAIN_NAV.removeAttribute('data-expanded');
      }
    })
  })
}

function INIT_RESET_MOBILE_NAV() {
  document.addEventListener('click', e => {
    e.stopImmediatePropagation();

    const NAVBAR_COLLAPSE = document.querySelector('.navbar-collapse');
    if (e.target.closest('.navbar') !== null) return;
    if (!NAVBAR_COLLAPSE) return;
    if (!HAS_NAV_MAX_WIDTH().matches || !NAVBAR_COLLAPSE.classList.contains('show')) return;

    Collapse.getOrCreateInstance(NAVBAR_COLLAPSE).hide();
  })
}

export function INIT_NAVIGATION() {
  const MAIN_NAV = GET_MAIN_NAV();
  const MAIN_HEADER = GET_MAIN_HEADER();
  if (!MAIN_NAV || !MAIN_HEADER) return;

  INIT_NAV_LINKS();
  CHECK_FOR_SCROLL();
  INIT_TOGGLER();
  INIT_RESET_MOBILE_NAV();

  window.addEventListener('scroll', () => CHECK_FOR_SCROLL());

  const NAVBAR_COLLAPSE = document.querySelector('.navbar-collapse');
  if (!NAVBAR_COLLAPSE || !NAVBAR_COLLAPSE.classList.contains('show')) return;

  Collapse.getOrCreateInstance(NAVBAR_COLLAPSE).hide();
}
